import React from 'react'
import { Col, Row } from 'antd'

const CashRegisterTabsContent = ({
  fetch,
  adjust,
  shopsList,
  fetchData,
  loading,
  onAdjust,
  selectedOption,
  searchText,
  component: TabContentComponent,
}) => (
  <Row gutter={16} className={'section-space-field'}>
    {selectedOption ? (
      !adjust ? (
        <Col span={24} className={'margin-top-15'}>
          {
            <TabContentComponent
              shopsList={shopsList}
              fetchData={fetchData}
              loading={loading}
              onAdjust={onAdjust}
              selectedOption={selectedOption}
              searchText={searchText}
            />
          }
        </Col>
      ) : (
        <Col span={24} className={'margin-top-15'}>
          {
            <TabContentComponent
              fetch={fetch}
              shopsList={shopsList}
              fetchData={fetchData}
              loading={loading}
              onAdjust={onAdjust}
              selectedOption={selectedOption}
              searchText={searchText}
            />
          }
        </Col>
      )
    ) : (
      <Col span={24} className={'empty-section-container'}>
        <div className={'empty-section'}>
          {!adjust ? (
            <span className={'empty-section-message'}>Por favor selecciona una tienda o realiza una búsqueda</span>
          ) : (
            <span className={'empty-section-message'}>Por favor selecciona una tienda</span>
          )}
        </div>
      </Col>
    )}
  </Row>
)

export default CashRegisterTabsContent
